export default __webpack_public_path__ + "static/media/comparison.27dd7959.svg";